import React from "react";
import { Message } from "semantic-ui-react";
import { LogOutLink } from "./LogOutLink";

const FiveHundredsError = ({ message }) => {
  return (
    <Message className="display-error centered-content" negative>
      <Message.Header>Oops, something went wrong...</Message.Header>
      <Message.Content>
        <p>{message !== "logout" ? message : <LogOutLink />}</p>
      </Message.Content>
    </Message>
  );
};
export default FiveHundredsError;
